import React from "react"
import { Link } from "gatsby"
import AiScreenCta from "../components/AiScreenCta"

const proof = [
  "15+ years",
  "5× AWS",
  "CKAD",
  "PMP",
  "Top Rated Plus · Upwork",
  "$100K+ earned",
]

const Hero = () => (
  <header className="hero">
    <div className="section-center hero-center">
      <div className="hero-grid">
        <article className="hero-info">
          <div className="underline"></div>
          <p className="hero-eyebrow">
            Nishant Tiwari <span>·</span> Agentic AI Engineer <span>·</span> Solutions Architect
          </p>
          <h1 className="hero-name">
            I build autonomous AI agents — and the platforms that run them.
          </h1>
          <p className="hero-pitch">
            15+ years shipping production systems across AWS, GCP &amp; Kubernetes.
          </p>
          <Link to="/contact" className="hero-availability">
            <span className="hero-availability-dot"></span>
            Available now — contract &amp; full-time, remote
          </Link>
        </article>

        <aside className="hero-aside">
          <AiScreenCta />
        </aside>
      </div>

      <ul className="hero-proof">
        {proof.map((item, i) => (
          <li key={i}>{item}</li>
        ))}
      </ul>
    </div>
  </header>
)

export default Hero
